module.exports = __webpack_public_path__ + "img/home.0b0f0995.svg";